module.exports = __webpack_public_path__ + "static/media/HaMaMo_Notice_bottom.c19ae5e6.png";